import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { useOnScreen } from 'site-modules/shared/hooks/use-on-screen';

export function RenderOnInteraction({
  children,
  placeholder = null,
  interactionEvents = ['keydown', 'scroll', 'click'],
  onRender = noop,
}) {
  const [shouldLoad, setShouldLoad] = useState(false);
  const placeholderRef = useRef();
  const [isIntersecting, disconnect] = useOnScreen(placeholderRef);

  function interactionComplete(e) {
    e.stopPropagation();

    if (!placeholderRef.current) {
      return;
    }

    setShouldLoad(true);
    // eslint-disable-next-line no-use-before-define
    removeListeners();
    disconnect();
    onRender();
  }

  function removeListeners() {
    interactionEvents.forEach(event => document.removeEventListener(event, interactionComplete));
  }

  useEffect(() => {
    interactionEvents.forEach(event => document.addEventListener(event, interactionComplete));

    return removeListeners;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isIntersecting) {
      // Intentional one-way load transition after intersection.
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShouldLoad(true);
    }
  }, [isIntersecting]);

  return shouldLoad ? children : <div ref={placeholderRef}>{placeholder}</div>;
}

RenderOnInteraction.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  placeholder: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  interactionEvents: PropTypes.arrayOf(PropTypes.string),
  onRender: PropTypes.func,
};
